module.exports = __webpack_public_path__ + "img/hamburguer-menu-light.b5aad97d.svg";